import { LANDING_URL, LANDING_TERMS_URL, LANDING_PRIVACY_URL } from '../../constants/urls';

// Site footer — copyright + legal links on the white page ground with a
// #D8D8D8 top rule. PageShell renders it under every full-width page.
//
// Terms and Privacy point at their permanent marketing-site pages; Support has
// no dedicated page yet, so it points at the site root.
const LINK = 'text-meta text-label no-underline transition-colors hover:text-ink-secondary';

export function SiteFooter() {
    return (
        <footer className="border-t border-placeholder bg-page">
            <div className="mx-auto flex max-w-content flex-wrap items-baseline justify-between gap-4 px-5 py-4 md:px-10">
                <span className="text-meta text-[#8B887C]">© {new Date().getFullYear()} Organic Electronics</span>
                <div className="flex items-baseline gap-6">
                    <a href={LANDING_TERMS_URL} className={LINK}>Terms of Use</a>
                    <a href={LANDING_PRIVACY_URL} className={LINK}>Privacy Policy</a>
                    <a href={LANDING_URL} className={LINK}>Support</a>
                </div>
            </div>
        </footer>
    );
}

export default SiteFooter;
